// extracted by mini-css-extract-plugin
export default {"root":"plain-message-modal_root__5qhYM","messageText":"plain-message-modal_messageText__DmKsd","placeHolderShimmer":"plain-message-modal_placeHolderShimmer__2f70X"};